import { BillingPeriod, BillingPeriodText } from "../../constants/billing";
import Select from "../Select/Select";

export function BillingPeriodSelector({ value, onChange, isSubmitting = false, ...props }) {
   return (
      <Select
         labelText="Ciclo de Cobrança *"
         value={value}
         onChange={({ target }) => {
            onChange({ target: { value: target.value } })
         }}
         disabled={props.type === "consulta" || isSubmitting}
         required={false}
         options={Object.keys(BillingPeriod).map((key) => ({
            value: BillingPeriod[key],
            text: BillingPeriodText[BillingPeriod[key]],
         }))}
         error={props.error}
      />
   );
}